import React from "react";
import { pad } from "../utils";
import { Delete } from "./icons/Delete";
import { Note } from "./icons/Note";
import { Pencil } from "./icons/Pencil";
import "../assets/styles/colors.css";

export const Alarm = ({ alarm, addEditItem, onDelete }) => {
  return (
    <div className={`alarm ${alarm.color}`}>
      <div>
        <p className="alarm-label">{alarm.label || "Alarm"}</p>
        <p className="alarm-time">
          {pad(alarm.hours)} : {pad(alarm.minutes)}
        </p>
        <div className="alarm-sound-container">
          <Note fill="var(--light)" size={15} />
          <p className="capitalize alarm-sound">{alarm.sound}</p>
        </div>
      </div>
      <div>
        <button className="btn btn-link" onClick={() => addEditItem(alarm)}>
          <Pencil fill="var(--light)" size={30} />
        </button>
        <button className="btn btn-link" onClick={() => onDelete(alarm.id)}>
          <Delete fill="var(--light)" size={30} />
        </button>
      </div>
    </div>
  );
};
